"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.devtoolLocalDashboard = exports.instantLogs = exports.devBackend = void 0;
let devBackend = false;
exports.devBackend = devBackend;
let instantLogs = false;
exports.instantLogs = instantLogs;
let devtoolLocalDashboard = false;
exports.devtoolLocalDashboard = devtoolLocalDashboard;
if (typeof window !== 'undefined' &&
    typeof window.localStorage !== 'undefined') {
    exports.devBackend = devBackend = !!window.localStorage.getItem('devBackend');
    exports.instantLogs = instantLogs = !!window.localStorage.getItem('__instantLogging');
    exports.devtoolLocalDashboard = devtoolLocalDashboard = !!window.localStorage.getItem('__devtoolLocalDash');
}
//# sourceMappingURL=flags.js.map